export var DND_LINE = 'dnd-line';
export var NOTE = 'note';
export var FILE_UPLOAD = 'file-upload';
export var IMAGE_GALLERY = 'image-gallery';
export default {
  DND_LINE: DND_LINE,
  FILE_UPLOAD: FILE_UPLOAD,
  IMAGE_GALLERY: IMAGE_GALLERY,
  NOTE: NOTE
};